<template>
  <div>
    <ts-loading-banner :loading="waiting">
      <div class="ts-h-screen">
        <div class="h-100">
          <!-- BEGIN pos -->
          <div
            class="pos pos-customer"
            v-bind:class="{ 'pos-mobile-sidebar-toggled': posMobileSidebar }"
            id="pos-customer"
          >
            <!-- BEGIN pos-menu -->
            <div class="pos-menu">
              <a href="#" @click.prevent="backHome">
                <div class="logo">
                  <div class="logo-img">
                    <img
                      v-lazy="{
                        src: companyLogo,
                        error: require('@/assets/logo.png')
                      }"
                    />
                  </div>
                  <!-- <div class="logo-text">Pine & Dine</div> -->
                </div>
              </a>
              <div class="nav-container overflow-auto">
                <div
                  data-scrollbar="true"
                  data-height="100%"
                  data-skip-mobile="true"
                >
                  <ts-tabs-horizontal target="gTab">
                    <ts-tab-horizontal @click="onChangeCategory">
                      <i class="fas fa-star fa-2x fa-fw"></i>
                      Top 20 Sale
                    </ts-tab-horizontal>
                    <ts-tab-horizontal
                      v-for="(c, index) in productCategory"
                      @click="onChangeCategory(c.category_id)"
                    >
                      <i :class="c.icon" class="fa-2x fa-fw"></i>
                      {{
                        locale == 'kh' ? c.category_name_kh : c.category_name_en
                      }}
                    </ts-tab-horizontal>
                  </ts-tabs-horizontal>
                </div>
              </div>
              <div
                class="pos-sidebar-footer ts-whitespace-no-wrap pos-sidebar-footer-left"
              >
                <h4 class="time text-center">{{ currentTime }}</h4>
                <div><i class="far fa-calendar-alt"></i> {{ currentDate }}</div>
                <div>
                  <i class="fas fa-user"></i>
                  {{ $store.state.authUser.user.name }}
                </div>
                <div>
                  FX
                  {{ exchangeRate + ' ' + toCurrency }}
                </div>
              </div>
            </div>
            <!-- END pos-menu -->

            <!-- BEGIN pos-content -->
            <div class="pos-content" data-scrollbar="true">
              <div
                class="ts-sticky ts-top-0 ts-z-50 ts-shadow-md sub-group"
                style="background: #f2f3f4;"
              >
                <div class="row">
                  <div class="col-lg-9">
                    <a-tabs
                      v-if="subCategories.length > 0"
                      v-model="activeKey"
                      :tab-position="mode"
                      :style="{ background: '#f2f3f4' }"
                      @prevClick="callback"
                      @nextClick="callback"
                      class="ts-sticky ts-top-0 ts-z-50 kh-font"
                    >
                      <a-tab-pane
                        v-for="c in subCategories"
                        :key="c.pro_group_id"
                        class="kh-font"
                      >
                        <span slot="tab">
                          <i :class="c.icon" class="fa-fw"></i>
                          {{
                            locale == 'kh'
                              ? c.pro_group_name_kh
                              : c.pro_group_name_en
                          }}
                        </span>
                      </a-tab-pane>
                    </a-tabs>
                    <a-tabs
                      v-if="categories.length > 0"
                      v-model="activeKeyCategory"
                      :tab-position="mode"
                      :style="{ background: '#f2f3f4' }"
                      @prevClick="callback"
                      @nextClick="callback"
                      class="ts-sticky ts-top-0 ts-z-50 kh-font"
                    >
                      <a-tab-pane
                        v-for="c in categories"
                        :key="c.category_id"
                        class="kh-font"
                      >
                        <span slot="tab">
                          <i :class="c.icon" class="fa-fw"></i>
                          {{
                            locale == 'kh'
                              ? c.category_name_kh
                              : c.category_name_en
                          }}
                        </span>
                      </a-tab-pane>
                    </a-tabs>
                  </div>
                  <div class="col-lg-3">
                    <div class="search-box">
                      <SearchBox
                        v-model="fetchOptions"
                        @onEnter="searchBarcode"
                      />
                      <div v-if="!fullscreen">
                        <button
                          @click="openFullscreen"
                          v-tooltip="'Open Fullscreen'"
                          class="nav-link"
                        >
                          <i class="fas fa-expand fa-2x"></i>
                        </button>
                      </div>
                      <div v-if="fullscreen">
                        <button
                          @click="closeFullscreen"
                          v-tooltip="'Close Fullscreen'"
                          class="nav-link"
                        >
                          <i class="fas fa-compress fa-2x"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ts-loading-banner :loading="productFetching">
                <ts-tab-panes-horizontal name="gTab">
                  <ts-tab-pane-horizontal
                    :class="{
                      'mt-1':
                        subCategories.length == 0 && categories.length == 0
                    }"
                  >
                    <div
                      class="product-container"
                      v-for="(pro, index) in products"
                      :key="index"
                    >
                      <div>
                        <a
                          class="btn btn-xs btn-block btn-info ts-z-40 rounded-0"
                          style="margin-bottom: -21px; position: relative;"
                          v-b-modal.modalPosItem
                          @click.prevent="selectProduct(pro.product_id)"
                          >{{ $t('martSale.details') }}</a
                        >
                        <a
                          href="#"
                          class="product"
                          @click.prevent="addProduct(pro.product_id)"
                        >
                          <img
                            class="img"
                            v-lazy="{
                              src: pro.photo
                                ? pro.photo
                                : require('@/assets/default-product.jpg'),
                              error: require('@/assets/default-product.jpg')
                              // loading: require('@/assets/Rolling-1s-200px_2.svg')
                            }"
                          />
                          <div class="text">
                            <div class="title ts-whitespace-no-wrap">
                              {{
                                pro.product_name_kh
                                  ? pro.product_name_kh
                                  : pro.product_name_en
                              }}
                            </div>
                            <div
                              class="desc ts-text-gray-700 ts-whitespace-no-wrap"
                            >
                              {{ pro.product_name_en }}
                            </div>
                            <div class="price">
                              <span class="text-info">{{ pro.barcode }}</span>
                              <span class="pull-right ts-text-blue-600"
                                >{{ defaultCrrency }}
                                {{
                                  defaultPrice(
                                    pro.product_id,
                                    dataSend.guest_level_id
                                  )
                                }}</span
                              >
                            </div>
                          </div>
                          <div class="tag-container">
                            <span
                              v-if="
                                getPromotionDiscount(
                                  pro.product_id,
                                  saleCodeByDefaultUom(pro.product_id)
                                    .unit_of_measure.uom_id,
                                  1
                                )
                              "
                              class="multi-tag"
                              >{{
                                getPromotionDiscount(
                                  pro.product_id,
                                  saleCodeByDefaultUom(pro.product_id)
                                    .unit_of_measure.uom_id,
                                  1
                                ).promo_discount_value
                              }}% {{ $t('restaurantSale.discount') }}</span
                            >
                            <span
                              v-if="
                                getPromotionBuyItemFreeItem(
                                  pro.product_id,
                                  saleCodeByDefaultUom(pro.product_id)
                                    .unit_of_measure.uom_id
                                )
                              "
                              class="multi-tag"
                              >{{
                                getPromotionBuyItemFreeItem(
                                  pro.product_id,
                                  saleCodeByDefaultUom(pro.product_id)
                                    ? saleCodeByDefaultUom(pro.product_id)
                                        .unit_of_measure.uom_id
                                    : 0
                                ).promotion_name
                              }}</span
                            >
                          </div>
                        </a>
                      </div>
                    </div>
                  </ts-tab-pane-horizontal>
                  <ts-tab-pane-horizontal v-for="(c, index) in productCategory">
                    <div
                      class="product-container"
                      v-for="(pro, index) in products"
                      :key="index"
                    >
                      <div>
                        <a
                          class="btn btn-xs btn-block btn-info ts-z-40 rounded-0"
                          style="margin-bottom: -10px; position: relative;"
                          v-b-modal.modalPosItem
                          @click.prevent="selectProduct(pro.product_id)"
                          >{{ $t('martSale.details') }}</a
                        >
                        <a
                          href="#"
                          class="product"
                          @click.prevent="addProduct(pro.product_id)"
                        >
                          <img
                            class="img"
                            v-lazy="{
                              src: pro.photo ? pro.photo : pro.photo,
                              error: require('@/assets/default-product.jpg')
                              // loading: require('@/assets/Rolling-1s-200px_2.svg')
                            }"
                          />
                          <div class="text">
                            <div class="title ts-whitespace-no-wrap">
                              {{
                                pro.product_name_kh
                                  ? pro.product_name_kh
                                  : pro.product_name_en
                              }}
                            </div>
                            <div
                              class="desc ts-text-gray-700 ts-whitespace-no-wrap"
                            >
                              {{ pro.product_name_en }}
                            </div>
                            <div class="price">
                              <span class="text-info">{{ pro.barcode }}</span>
                              <span class="pull-right ts-text-blue-600"
                                >{{ defaultCrrency }}
                                {{
                                  defaultPrice(
                                    pro.product_id,
                                    dataSend.guest_level_id
                                  )
                                }}</span
                              >
                            </div>
                          </div>
                          <div class="tag-container">
                            <span
                              v-if="
                                getPromotionDiscount(
                                  pro.product_id,
                                  saleCodeByDefaultUom(pro.product_id)
                                    .unit_of_measure.uom_id,
                                  1
                                )
                              "
                              class="multi-tag"
                              >{{
                                getPromotionDiscount(
                                  pro.product_id,
                                  saleCodeByDefaultUom(pro.product_id)
                                    .unit_of_measure.uom_id,
                                  1
                                ).promo_discount_value
                              }}% {{ $t('restaurantSale.discount') }}</span
                            >
                            <span
                              v-if="
                                getPromotionBuyItemFreeItem(
                                  pro.product_id,
                                  saleCodeByDefaultUom(pro.product_id)
                                    .unit_of_measure.uom_id
                                )
                              "
                              class="multi-tag"
                              >{{
                                getPromotionBuyItemFreeItem(
                                  pro.product_id,
                                  saleCodeByDefaultUom(pro.product_id)
                                    ? saleCodeByDefaultUom(pro.product_id)
                                        .unit_of_measure.uom_id
                                    : 0
                                ).promotion_name
                              }}</span
                            >
                          </div>
                        </a>
                      </div>
                    </div>
                  </ts-tab-pane-horizontal>
                </ts-tab-panes-horizontal>
              </ts-loading-banner>
            </div>
            <!-- END pos-content -->
            <!-- BEGIN pos-sidebar -->
            <div class="pos-sidebar" id="pos-sidebar">
              <div class="pos-sidebar-header">
                <div class="back-btn">
                  <button
                    type="button"
                    v-on:click="posMobileSidebarToggled"
                    class="btn"
                  >
                    <svg
                      viewBox="0 0 16 16"
                      class="bi bi-chevron-left"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                      />
                    </svg>
                  </button>
                </div>
                <div class="icon">
                  <img src="@/assets/icon-table.svg" style="max-width: 40px;" />
                </div>
                <div class="title">
                  {{ $t('restaurantSale.table') }}
                  {{ tableSelected ? tableSelected.table_no : '' }}
                </div>
                <div class="order">
                  {{ $t('restaurantSale.order') }}:
                  <b>#{{ dataSend.order_no }}</b>
                </div>
              </div>
              <div class="pos-sidebar-nav">
                <ul class="nav nav-tabs nav-fill">
                  <li class="nav-item">
                    <a
                      class="nav-link active"
                      href="#"
                      data-toggle="tab"
                      data-target="#newOrderTab"
                      >{{ $t('restaurantSale.newOrder') }} ({{
                        dataSend.products.length
                      }})</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      style="padding: 4px 0 !important;"
                      href="#"
                      data-toggle="tab"
                      data-target="#orderHistoryTab"
                    >
                      <div class="btn-group btn-group-justified">
                        <a
                          v-for="language in languages"
                          :key="language.code"
                          @click="changeLanguage(language)"
                          class="btn btn-default"
                          :class="{ 'btn-info': language.code == locale }"
                        >
                          <span
                            :class="
                              `flag-icon flag-icon-${language.icon} ts-text-lg`
                            "
                            :title="language.icon"
                          ></span>
                          {{ language.caption }}
                        </a>
                      </div></a
                    >
                  </li>
                </ul>
              </div>
              <div
                class="pos-sidebar-body tab-content"
                data-scrollbar="true"
                data-height="100%"
              >
                <div class="tab-pane fade show active" id="newOrderTab">
                  <div class="pos-table" ref="add_to_card">
                    <div
                      class="row pos-table-row"
                      v-for="(order, index) in orderBy(dataSend.products)"
                      :key="index"
                    >
                      <div class="col-9">
                        <div class="pos-product-thumb">
                          <div class="img ts-text-center">
                            <img
                              class="img"
                              v-lazy="{
                                src: getProduct(order.product_id)
                                  ? getProduct(order.product_id).photo
                                  : '',
                                error: require('@/assets/default-product.jpg'),
                                loading: require('@/assets/Rolling-1s-200px_2.svg')
                              }"
                            />
                            <span class="text-info ts-font-bold">
                              {{
                                getProduct(order.product_id)
                                  ? getProduct(order.product_id).barcode
                                  : ''
                              }}
                            </span>
                          </div>
                          <div class="info">
                            <div class="title">
                              {{
                                getProduct(order.product_id)
                                  ? getProduct(order.product_id).product_name_kh
                                    ? getProduct(order.product_id)
                                        .product_name_kh
                                    : getProduct(order.product_id)
                                        .product_name_en
                                  : ''
                              }}
                              <small>{{
                                order.remarks ? '(' + order.remarks + ')' : ''
                              }}</small>
                            </div>
                            <div class="single-price">
                              <span class="ts-text-blue-600"
                                >{{ defaultCrrency }}
                                {{ order.unit_price }}</span
                              >
                              - {{ $t('restaurantSale.size') }}:
                              {{ getUomName(order.product_id, order.uom_id) }}
                            </div>
                            <div class="desc">
                              - {{ $t('restaurantSale.discount') }}
                              {{
                                order.discount_rate
                                  ? '(' + order.discount_rate + '%)'
                                  : ''
                              }}:
                              <span class="text-warning"
                                >{{ defaultCrrency }}
                                {{ order.discount_amount }}</span
                              >
                            </div>
                            <div class="ts-flex ts-items-center">
                              <div class="input-group qty">
                                <div class="input-group-append">
                                  <a
                                    href="#"
                                    class="btn btn-default"
                                    @click.prevent="
                                      ;[
                                        setPromotionItemFreeItem(
                                          order.product_id,
                                          order.uom_id,
                                          order.unit_price,
                                          order.quantity-- - 1
                                        ),
                                        setPromotionDiscountOrdered(order)
                                      ]
                                    "
                                    :disabled="
                                      order.quantity <= 1 ||
                                        isAllowAdjustFreeQuantity(order)
                                    "
                                    ><i class="fa fa-minus"></i
                                  ></a>
                                </div>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model.number="order.quantity"
                                  @input="
                                    ;[
                                      setPromotionItemFreeItem(
                                        order.product_id,
                                        order.uom_id,
                                        order.unit_price,
                                        order.quantity
                                      ),
                                      setPromotionDiscountOrdered(order)
                                    ]
                                  "
                                  @focus="$event.target.select()"
                                  :class="{
                                    'is-invalid': errors.has(
                                      'products.' + index + '.quantity'
                                    )
                                  }"
                                  :disabled="isAllowAdjustFreeQuantity(order)"
                                />
                                <div class="input-group-prepend">
                                  <a
                                    href="#"
                                    class="btn btn-default"
                                    @click.prevent="
                                      ;[
                                        setPromotionItemFreeItem(
                                          order.product_id,
                                          order.uom_id,
                                          order.unit_price,
                                          order.quantity++ + 1
                                        ),
                                        setPromotionDiscountOrdered(order)
                                      ]
                                    "
                                    :disabled="isAllowAdjustFreeQuantity(order)"
                                    ><i class="fa fa-plus"></i
                                  ></a>
                                </div>
                              </div>
                              <div>
                                <input
                                  v-model="order.discount_rate"
                                  type="number"
                                  @focus="$event.target.select()"
                                  placeholder="discount"
                                  class="ts-w-12 ts-font-semibold ts-mt-2 ts-ml-3 ts-px-1 ts-py-1 ts-rounded-sm ts-border ts-outline-none ts-border-gray-400 ts-text-center"
                                />
                                <span class="ts-font-semibold ts-ml-1">%</span>
                              </div>
                            </div>
                            <div
                              class="validate"
                              v-if="
                                errors.has('products.' + index + '.quantity')
                              "
                            >
                              {{
                                errors.first('products.' + index + '.quantity')
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-3 total-price text-success">
                        {{ defaultCrrency }} {{ order.grand_total }}
                        <br />
                        <br />
                        <small
                          v-if="
                            order.cooking_status_id == 2 ||
                              order.cooking_status_id == 2
                          "
                          class="desc"
                          :class="cookingStatus(order.cooking_status_id)"
                          ><i class="fas fa-mortar-pestle"></i>
                          {{ order.cooking_status }}</small
                        >
                        <a
                          href="#"
                          class="btn btn-danger btn-xs"
                          v-if="
                            order.cooking_status_id != 2 ||
                              order.cooking_status_id != 3
                          "
                          @click.prevent="
                            () => [
                              (product_id_delete = order.product_id),
                              (uom_id_delete = order.uom_id),
                              (quantity_delete = order.quantity),
                              (unit_price_delete = order.unit_price)
                            ]
                          "
                        >
                          <i class="fa fa-trash"></i>
                        </a>
                      </div>
                      <div
                        class="pos-remove-confirmation"
                        v-if="
                          product_id_delete == order.product_id &&
                            uom_id_delete == order.uom_id &&
                            quantity_delete == order.quantity &&
                            unit_price_delete == order.unit_price
                        "
                      >
                        <svg
                          width="2em"
                          height="2em"
                          viewBox="0 0 16 16"
                          class="mr-2"
                          fill="currentColor"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
                          />
                          <path
                            fill-rule="evenodd"
                            d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                          />
                        </svg>
                        {{ $t('are_you_sure_to_delete') }}
                        <a
                          href="#"
                          class="btn btn-white ml-auto mr-2"
                          @click.prevent="
                            () => [
                              (product_id_delete = null),
                              (uom_id_delete = null),
                              (quantity_delete = null),
                              (unit_price_delete = null)
                            ]
                          "
                          >{{ $t('no') }}</a
                        >
                        <a
                          href="#"
                          class="btn btn-danger"
                          @click.prevent="removeItem(order)"
                          >{{ $t('yes') }}</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade h-100" id="orderHistoryTab">
                  <div
                    class="h-100 d-flex align-items-center justify-content-center text-center p-20"
                  >
                    <div>
                      <div class="mb-3 mt-n5">
                        <svg
                          width="6em"
                          height="6em"
                          viewBox="0 0 16 16"
                          class="text-gray-300"
                          fill="currentColor"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M14 5H2v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5zM1 4v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4H1z"
                          />
                          <path
                            d="M8 1.5A2.5 2.5 0 0 0 5.5 4h-1a3.5 3.5 0 1 1 7 0h-1A2.5 2.5 0 0 0 8 1.5z"
                          />
                        </svg>
                      </div>
                      <h4>{{ $t('restaurantSale.noOrderHistoryFound') }}</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pos-sidebar-footer ts-whitespace-no-wrap">
                <div class="subtotal">
                  <div class="text">{{ $t('restaurantSale.subtotal') }}</div>
                  <div class="price">
                    {{ defaultCrrency }} {{ dataSend.sub_total }}
                  </div>
                </div>
                <div class="taxes">
                  <div class="text">
                    VAT {{ vatRate ? '(' + vatRate + '%)' : '' }}
                  </div>
                  <div class="price">
                    {{ defaultCrrency }} {{ dataSend.vat_amount }}
                  </div>
                </div>
                <hr class="opacity-1" />
                <div class="total">
                  <div class="text">{{ $t('restaurantSale.grandTotal') }}</div>
                  <div class="price">
                    {{ defaultCrrency }} {{ dataSend.grand_total }}
                  </div>
                </div>
                <div class="btn-row ts-space-x-2">
                  <ts-button @click.prevent="checkBill"
                    ><i class="fa fa-arrow-left fa-fw fa-lg"></i>
                    {{ $t('restaurantSale.back') }}</ts-button
                  >
                  <!-- <ts-button color="info" disabled
                  ><i class="fa fa-file fa-fw fa-lg"></i>
                  {{ $t('restaurantSale.reprint') }}</ts-button
                > -->
                  <ts-button
                    color="success"
                    @click.prevent="submitOrder"
                    :waiting="waiting"
                    :disabled="
                      waiting || (tableSelected.table_id ? false : true)
                    "
                    ><i
                      class="fa fa-shopping-cart fa-fw fa-lg"
                      v-if="!waiting"
                    ></i>
                    {{ $t('restaurantSale.submitOrder') }}</ts-button
                  >
                </div>
              </div>
            </div>
            <!-- END pos-sidebar -->
          </div>
          <!-- END pos -->

          <!-- BEGIN pos-mobile-sidebar-toggler -->
          <a
            href="#"
            class="pos-mobile-sidebar-toggler"
            v-on:click="posMobileSidebarToggled"
          >
            <svg
              viewBox="0 0 16 16"
              class="img"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M14 5H2v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5zM1 4v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4H1z"
              />
              <path
                d="M8 1.5A2.5 2.5 0 0 0 5.5 4h-1a3.5 3.5 0 1 1 7 0h-1A2.5 2.5 0 0 0 8 1.5z"
              />
            </svg>
            <span class="badge">{{ dataSend.products.length }}</span>
          </a>
          <!-- END pos-mobile-sidebar-toggler -->

          <!-- BEGIN #modalPosItem -->
          <b-modal
            modal-class="modal-pos-item"
            :hide-header="true"
            :hide-footer="true"
            size="lg"
            body-class="p-0"
            id="modalPosItem"
            centered
          >
            <form>
              <a href="#" class="close" @click="close"
                ><i class="fa fa-times"></i
              ></a>
              <div class="pos-product" v-for="(p, index) in selectedProduct">
                <div class="pos-product-img">
                  <img
                    class="img"
                    v-lazy="{
                      src: p.photo,
                      error: require('@/assets/default-product.jpg'),
                      loading: require('@/assets/Rolling-1s-200px_2.svg')
                    }"
                  />
                </div>
                <div class="pos-product-info">
                  <div class="title">
                    {{
                      p.product_name_kh ? p.product_name_kh : p.product_name_en
                    }}
                  </div>
                  <div class="desc">
                    {{ p.product_name_en }}
                  </div>
                  <div class="price">
                    {{ defaultCrrency }}
                    {{ defaultPrice(p.product_id, dataSend.guest_level_id) }}
                  </div>
                  <b-alert
                    v-if="
                      getPromotionBuyItemFreeItem(
                        p.product_id,
                        saleCodeByDefaultUom(p.product_id)
                          ? saleCodeByDefaultUom(p.product_id).unit_of_measure
                              .uom_id
                          : 0
                      )
                    "
                    variant="success"
                    show
                  >
                    Buy
                    <strong>
                      {{
                        getPromotionBuyItemFreeItem(
                          p.product_id,
                          saleCodeByDefaultUom(p.product_id)
                            ? saleCodeByDefaultUom(p.product_id).unit_of_measure
                                .uom_id
                            : 0
                        ).free_item.buy_quantity
                      }}
                    </strong>
                    Get Promotion
                    {{
                      getPromotionBuyItemFreeItem(
                        p.product_id,
                        saleCodeByDefaultUom(p.product_id)
                          ? saleCodeByDefaultUom(p.product_id).unit_of_measure
                              .uom_id
                          : 0
                      ).free_item.condition_type
                    }}
                    Item.
                    <br />
                    <table width="100%" class="text-primary">
                      <tr>
                        <th>Item Name</th>
                        <th class="text-center">QTY</th>
                        <th class="text-right">Price</th>
                      </tr>
                      <tr
                        v-for="(item, index) in getPromotionBuyItemFreeItem(
                          p.product_id,
                          saleCodeByDefaultUom(p.product_id)
                            ? saleCodeByDefaultUom(p.product_id).unit_of_measure
                                .uom_id
                            : 0
                        ).free_item.free_item_list"
                        :key="index"
                      >
                        <td>{{ item.product_name_free_en }}</td>
                        <td class="text-center">{{ item.free_quantity }}</td>
                        <td class="text-right">{{ item.price }}</td>
                      </tr>
                    </table>
                  </b-alert>
                  <hr />
                  <div class="option-row">
                    <div class="qty">
                      <div class="input-group">
                        <a
                          href="#"
                          class="btn btn-default"
                          @click.prevent="decrement"
                          :disabled="quantity <= 1"
                          ><i class="fa fa-minus"></i
                        ></a>
                        <input
                          type="text"
                          class="form-control border-0 text-center"
                          v-model.number="quantity"
                          style="padding: 0"
                          @focus="$event.target.select()"
                        />
                        <a
                          href="#"
                          class="btn btn-default"
                          @click.prevent="increment"
                          ><i class="fa fa-plus"></i
                        ></a>
                      </div>
                    </div>
                  </div>
                  <div class="option-row" style="width: 94px">
                    <input
                      autofocus
                      type="number"
                      class="form-control text-center"
                      v-model.number="discount_rate"
                      placeholder="Dis %"
                      @focus="$event.target.select()"
                    />
                  </div>
                  <div class="option-row">
                    <div class="option-title">
                      {{ $t('restaurantSale.size') }}
                    </div>
                    <div class="option-list" v-if="p.sale_code.length > 0">
                      <div class="option" v-for="(s, index) in p.sale_code">
                        <input
                          type="radio"
                          :id="'size' + s.pro_sale_code_id"
                          v-model="size"
                          :value="s.unit_of_measure.uom_id"
                          class="option-input"
                          checked
                          @input="chooseSize(s)"
                        />
                        <label
                          class="option-label"
                          :for="'size' + s.pro_sale_code_id"
                        >
                          <span class="option-text">{{
                            s.unit_of_measure.uom_name_en
                          }}</span>
                          <span class="option-price"
                            >{{ defaultCrrency }}
                            {{
                              s.product_price ? s.product_price.sale_price : ''
                            }}</span
                          >
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="option-row" v-if="p.product_add_on.length > 0">
                    <div class="option-title">
                      {{ $t('restaurantSale.addOn') }}
                    </div>
                    <div class="option-list">
                      <div
                        class="option"
                        v-for="(add_on, index) in p.product_add_on"
                      >
                        <input
                          type="checkbox"
                          v-model="addon"
                          :value="add_on"
                          class="option-input"
                          :id="'addon' + add_on.addon_pro_sale_code_id"
                          @input="chooseAddOn(add_on ? add_on.sale_code : '')"
                        />
                        <label
                          class="option-label"
                          :for="'addon' + add_on.addon_pro_sale_code_id"
                        >
                          <span class="option-text">{{
                            add_on.sale_code
                              ? add_on.sale_code.product.product_name_en
                              : ''
                          }}</span>
                          <span class="option-price"
                            >+ {{ defaultCrrency }}
                            {{
                              add_on.sale_code
                                ? add_on.sale_code.product_price
                                  ? add_on.sale_code.product_price.sale_price
                                  : 0
                                : ''
                            }}</span
                          >
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="option-row">
                    <textarea
                      rows="2"
                      class="form-control"
                      v-model="remarks"
                      :placeholder="$t('restaurantSale.remarks')"
                    ></textarea>
                  </div>
                  <div class="btn-row">
                    <a
                      href="#"
                      class="btn btn-default"
                      data-dismiss="modal"
                      @click.prevent="close"
                      >{{ $t('restaurantSale.cancel') }}</a
                    >
                    <ts-button
                      type="submit"
                      color="success"
                      @click.prevent="addToCart"
                      >{{ $t('restaurantSale.addToCart') }}
                      <i class="fa fa-plus fa-fw ml-2"></i
                    ></ts-button>
                  </div>
                </div>
              </div>
            </form>
          </b-modal>
          <!-- END #modalPosItem -->
          <!-- BEGIN #modalPosItem -->
          <a-modal
            v-model="visible"
            :title="
              promotion_free_item_per_amount
                ? promotion_free_item_per_amount.promotion_name
                : ''
            "
            on-ok="handleOk"
          >
            <template slot="footer">
              <a-button key="back" @click="handleCancel">
                {{ $t('restaurantSale.cancel') }}
              </a-button>
              <a-button
                key="submit"
                type="primary"
                :loading="waiting"
                @click="handleOk"
              >
                {{ $t('restaurantSale.addFreeItem') }}
              </a-button>
            </template>
            <table
              id="list"
              class="table table-hover ui-table ts-table"
              v-if="conditions"
            >
              <thead>
                <tr>
                  <th class="text-center">
                    <ts-checkbox
                      v-if="conditions.free_status == 'All'"
                      @change="selectAll"
                      v-model="checked_all"
                    ></ts-checkbox>
                  </th>
                  <th class="ts-whitespace-no-wrap">
                    {{ $t('restaurantSale.productName') }}
                  </th>
                  <th class="ts-whitespace-no-wrap text-center">
                    {{ $t('restaurantSale.uom') }}
                  </th>
                  <th class="ts-whitespace-no-wrap text-center">
                    {{ $t('restaurantSale.quantity') }}
                  </th>
                </tr>
              </thead>
              <tbody v-if="conditions">
                <tr
                  v-for="(record, index) in conditions.discount_items"
                  :key="index"
                >
                  <td class="text-center">
                    <ts-checkbox
                      v-if="conditions.free_status == 'All'"
                      :value="{
                        product_id: record.product_id,
                        uom_id: record.uom_id,
                        quantity: record.quantity
                      }"
                      v-model="selectedProductFree"
                      @change="
                        selectedProductFree.length ==
                        conditions.discount_items.length
                          ? (checked_all = true)
                          : (checked_all = false)
                      "
                    ></ts-checkbox>
                    <input
                      v-if="conditions.free_status == 'Any'"
                      type="radio"
                      v-model="selectedProductFree"
                      :value="[
                        {
                          product_id: record.product_id,
                          uom_id: record.uom_id,
                          quantity: record.quantity
                        }
                      ]"
                      :checked="
                        selectedProductFree[0].product_id ==
                          record.product_id &&
                        selectedProductFree[0].uom_id == record.uom_id &&
                        selectedProductFree[0].quantity == record.quantity
                          ? true
                          : false
                      "
                    />
                  </td>
                  <td class="ts-whitespace-no-wrap">
                    {{ record.product_name_en }}
                  </td>
                  <td class="ts-whitespace-no-wrap text-center">
                    {{ record.uom_name_en }}
                  </td>
                  <td class="ts-whitespace-no-wrap text-center">
                    {{ record.quantity }}
                  </td>
                </tr>
              </tbody>
            </table>
          </a-modal>
          <!-- END #modalPosItem -->
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import PageOptions from '@/config/PageOptions.vue'
import SearchBox from './components/search-box'
import { mapActions, mapGetters, mapState } from 'vuex'
import moment from 'moment'
import { Errors } from 'form-backend-validation'
import { debounce, orderBy } from 'lodash'

export default {
  name: 'restaurantSale',
  components: {
    SearchBox
  },
  data() {
    return {
      activeKey: '',
      activeKeyCategory: '',
      mode: 'top',
      errors: new Errors(),
      posMobileSidebar: false,
      loading: false,
      waiting: false,
      visible: false,
      checked_all: false,
      productFetching: false,
      showChooseFreeItems: true,
      selectedProductId: null,
      quantity: 1,
      size: null,
      selectedProductFree: [],
      addon: [],
      products: [],
      subCategories: [],
      categories: [],
      remarks: null,
      discount_rate: null,
      promo_type_id: null,
      currentTime: '',
      currentDate: '',
      promotion_free_item_per_amount: {},
      conditions: {},
      fetchOptions: {
        search_value: ''
      },
      item: {
        product_id: null,
        uom_id: null,
        quantity: null,
        unit_price: null,
        discount_type: null,
        discount_rate: null,
        discount_amount: null,
        total_after_discount: null,
        vat_rate: null,
        vat_amount: null,
        grand_total: null,
        remarks: null,
        promo_free_item_cond_id: null,
        promo_type_id: null,
        is_allow_adjust_free_quantity: false
      },
      itemAddon: [],
      dataSend: {
        customer_id: null,
        stock_out_id: null,
        counter_id: null,
        table_id: null,
        num_customer: null,
        order_no: null,
        sub_total: 0,
        discount_type: null,
        discount_rate: null,
        discount_amount: null,
        total_after_discount: 0,
        vat_amount: 0,
        vat_rate: 0,
        grand_total: 0,
        fx_rate: 0,
        remark: null,
        products: [],
        guest_level_id: null
      },
      languages: [
        { code: 'kh', icon: 'kh', caption: 'ខ្មែរ' },
        { code: 'en', icon: 'us', caption: 'English' }
      ],
      product_id_delete: null,
      uom_id_delete: null,
      quantity_delete: null,
      unit_price_delete: null,
      fullscreen: false
    }
  },
  filters: {
    format_number(value) {
      return `${value.toLocaleString()}`
    }
  },
  computed: {
    ...mapGetters('restaurantSale/customerOrder', [
      'defaultPrice',
      'saleCodeByDefaultUom',
      'getUomName',
      'getProduct',
      'getPromotionDiscount',
      'getPromotionItemFreeItem',
      'getPromotionBuyItemFreeItem',
      'getPromotionFreeItemPerAmount'
    ]),
    ...mapState('restaurantSale/customerOrder', ['companyInfo']),
    productCategory() {
      return this.$store.state.restaurantSale.customerOrder.productCategories
    },
    tableSelected() {
      return this.$store.state.restaurantSale.counterCheckout.tableSelected
    },
    companyLogo() {
      return this.companyInfo.length > 0 ? this.companyInfo[0].company_logo : ''
    },
    selectedProduct() {
      return this.$store.state.restaurantSale.customerOrder.products.filter(
        s => s.product_id == this.selectedProductId
      )
    },
    vatRate() {
      return parseFloat(
        this.$store.state.restaurantSale.customerOrder.systemSettings.vat_rate
      )
    },
    exchangeRate() {
      return parseFloat(
        this.$store.state.restaurantSale.customerOrder.systemSettings.fx_rate
      )
    },
    defaultCrrency() {
      return this.$store.state.restaurantSale.customerOrder.systemSettings
        .default_currency
    },
    toCurrency() {
      return this.$store.state.restaurantSale.customerOrder.systemSettings
        .to_currency
    },
    locale() {
      return this.$root.$i18n.locale
    },
    flag() {
      if (this.$root.$i18n.locale === 'kh') return 'kh'
      else if (this.$root.$i18n.locale === 'en') return 'us'
    }
  },
  async created() {
    PageOptions.pageEmpty = true
    this.productFetching = true
    await this.fetchBefore().then(() => this.fetchProducts())
    this.checkReload()
    setInterval(() => this.updateCurrentTime(), 1 * 1000)
    this.dataSend.counter_id = parseInt(localStorage.getItem('counterId'))
    if (_.isEmpty(this.tableSelected)) {
      this.$router.push({ name: 'counter-checkout-order' })
    }
  },
  methods: {
    ...mapActions('restaurantSale/customerOrder', ['fetchBefore', 'store']),
    checkReload() {
      window.onbeforeunload = function() {
        return 'Are you sure you want to close the window?'
      }
    },
    async fetchProducts(attributes) {
      await this.$store
        .dispatch('restaurantSale/customerOrder/fetchProducts', attributes)
        .then(() => {
          this.onChangeCategory(null)
          this.setDataOnSelectedTable()
        })
        .finally(() => (this.productFetching = false))
    },
    posMobileSidebarToggled: function() {
      this.posMobileSidebar = !this.posMobileSidebar
    },
    searchBarcode() {
      var product = this.$store.state.restaurantSale.customerOrder.products
        .filter(
          p =>
            p.barcode == this.fetchOptions.search_value ||
            p.product_name_en == this.fetchOptions.search_value ||
            p.product_name_kh == this.fetchOptions.search_value
        )
        .reduce((init, value) => (init = value), null)
      if (product) {
        this.selectProduct(product.product_id)
        this.addToCart()
        this.fetchOptions.search_value = ''
      } else {
        this.$notification['info']({
          message: 'Search Barcode',
          description: 'Not found product!',
          placement: 'buttomRight'
        })
        this.fetchOptions.search_value = ''
      }
    },
    onChangeCategory(category_id) {
      this.category_id = category_id
      this.categories = []
      this.subCategories = []
      this.activeKey = ''
      this.activeKeyCategory = ''
      this.fetchOptions.search_value = ''
      if (category_id) {
        // get product specify  category
        this.subCategories = this.productCategory.filter(
          c => c.category_id == category_id
        )[0].sub_categories
        this.products = this.$store.state.restaurantSale.customerOrder.products.filter(
          p =>
            _.includes([1, 2], p.product_type_id) &&
            p.category_id == category_id
        )
        return
      }
      this.products = this.$store.state.restaurantSale.customerOrder.products.filter(
        p =>
          _.includes([1, 2], p.product_type_id) &&
          _.includes(
            p.sale_code.map(s => s.is_top_sale),
            true
          )
      )
      this.categories = this.productCategory.filter(c =>
        _.includes(_.uniq(this.products.map(p => p.category_id)), c.category_id)
      )
      this.subCategories = []
      return
    },
    onChangeSubCategory(pro_group_id) {
      this.fetchOptions.search_value = ''
      if (pro_group_id) {
        // get product specify sub category
        this.products = this.$store.state.restaurantSale.customerOrder.products.filter(
          p =>
            _.includes([1, 2], p.product_type_id) &&
            p.product_group.pro_group_id == pro_group_id
        )
        return
      }
    },
    onChangeMainCategory(category_id) {
      this.fetchOptions.search_value = ''
      if (category_id) {
        // get product specify main category
        this.products = this.$store.state.restaurantSale.customerOrder.products.filter(
          p =>
            p.category_id == category_id &&
            _.includes([1, 2], p.product_type_id) &&
            _.includes(
              p.sale_code.map(s => s.is_top_sale),
              true
            )
        )
        return
      }
    },
    selectProduct(product_id) {
      this.clearOldSelectPro()
      this.selectedProductId = product_id
      let saleCode = this.saleCodeByDefaultUom(product_id)
      this.size = saleCode.unit_of_measure.uom_id
      this.chooseSize(saleCode)
    },
    addProduct(product_id) {
      this.clearOldSelectPro()
      this.selectedProductId = product_id
      let saleCode = this.saleCodeByDefaultUom(product_id)
      this.size = saleCode.unit_of_measure.uom_id
      this.chooseSize(saleCode)
      this.addToCart()
    },
    setPromotionDiscount(product_id, uom_id, quantity) {
      let promotion_discount = this.getPromotionDiscount(
        product_id,
        uom_id,
        quantity
      )
      this.remarks = promotion_discount
        ? promotion_discount.promotion_name
        : null
      this.discount_rate = promotion_discount
        ? promotion_discount.promo_discount_value
        : null
      this.promo_type_id = promotion_discount
        ? promotion_discount.promo_type_id
        : null
    },
    setPromotionDiscountOrdered(order) {
      let promotion_discount = this.getPromotionDiscount(
        order.product_id,
        order.uom_id,
        order.quantity
      )
      order.remarks = promotion_discount
        ? promotion_discount.promotion_name
        : null
      order.discount_rate = promotion_discount
        ? promotion_discount.promo_discount_value
        : null
      order.promo_type_id = promotion_discount
        ? promotion_discount.promo_type_id
        : null
    },
    clearOldSelectPro() {
      this.quantity = 1
      this.size = null
      this.addon = []
      this.remarks = null
      this.discount_rate = null
      this.promo_type_id = null
      this.itemAddon = []
    },
    increment() {
      this.quantity++
    },
    decrement() {
      this.quantity--
    },
    chooseSize(saleCode) {
      this.addItem(saleCode)
    },
    chooseAddOn(saleCode) {
      this.addItem(saleCode, true)
    },
    addToCart() {
      //clear search value when click add product
      this.fetchOptions.search_value = ''
      var dis = this.dataSend.products
        .filter(p => p.product_id == this.item.product_id)
        .reduce((init, value) => (init = value.discount_rate), 0)
      this.item.quantity = this.quantity
      this.item.discount_rate = this.discount_rate ? this.discount_rate : dis
      this.item.promo_type_id = this.promo_type_id
      this.item.remarks = this.remarks
      this.item.promo_free_item_cond_id = null
      this.$forceUpdate()
      let var_product = this.dataSend.products
        .filter(
          p =>
            p.product_id == this.item.product_id &&
            p.uom_id == this.item.uom_id &&
            p.unit_price > 0
        )
        .reduce((init, value) => (init = value), {})
      if (!_.isEmpty(var_product)) {
        var_product.quantity += this.item.quantity
        this.setPromotionDiscount(
          this.item.product_id,
          this.item.uom_id,
          var_product.quantity
        )
        var_product.discount_rate = this.discount_rate
          ? this.discount_rate
          : dis
        var_product.remarks = this.remarks
        this.calculate()
        this.setPromotionItemFreeItem(
          this.item.product_id,
          this.item.uom_id,
          this.item.unit_price,
          var_product.quantity
        )
        //move to index 0
        this.arraymove(
          this.dataSend.products,
          this.dataSend.products.indexOf(var_product),
          this.dataSend.products.length + 1
        )
      } else {
        this.setPromotionDiscount(
          this.item.product_id,
          this.item.uom_id,
          this.item.quantity
        )
        this.item.discount_rate = this.discount_rate
        this.item.promo_type_id = this.promo_type_id
        this.item.remarks = this.remarks
        this.dataSend.products.push(_.clone(this.item))
        this.dataSend.vat_rate = parseFloat(
          this.$store.state.restaurantSale.customerOrder.systemSettings.vat_rate
        )
        this.setPromotionItemFreeItem(
          this.item.product_id,
          this.item.uom_id,
          this.item.unit_price,
          this.item.quantity
        )
      }
      this.itemAddon.forEach(el => {
        let duplicate = this.dataSend.products.filter(
          p => p.product_id == el.product_id && p.uom_id == el.uom_id
        )
        if (duplicate.length > 0) {
          duplicate[0].quantity += el.quantity
          //move to index 0
          this.arraymove(
            this.dataSend.products,
            this.dataSend.products.indexOf(duplicate[0]),
            this.dataSend.products.length + 1
          )
        } else {
          this.dataSend.products.push(_.clone(el))
        }
      })
      this.close()
      this.scrollToBottom()
    },
    setPromotionItemFreeItem(product_id, uom_id, unit_price, quantity) {
      if (unit_price > 0) {
        var free_item = this.getPromotionItemFreeItem(
          product_id,
          uom_id,
          quantity
        )
        if (free_item) {
          free_item.map(el => {
            if (el.quantity > 0) {
              let var_product = this.dataSend.products
                .filter(
                  p =>
                    p.product_id == el.product_id &&
                    p.uom_id == el.uom_id &&
                    p.promo_type_id == el.promotions.promo_type_id
                )
                .reduce((init, value) => (init = value), {})

              if (!_.isEmpty(var_product)) {
                var_product.quantity = el.quantity
                this.arraymove(
                  this.dataSend.products,
                  this.dataSend.products.indexOf(var_product),
                  this.dataSend.products.length + 1
                )
              } else {
                this.item.product_id = el.product_id
                this.item.uom_id = el.uom_id
                this.item.quantity = el.quantity
                this.item.unit_price = el.unit_price
                this.item.discount_rate = 0
                this.item.remarks = el.promotions.promotion_name
                this.item.promo_type_id = el.promotions.promo_type_id
                this.item.is_allow_adjust_free_quantity =
                  el.is_allow_adjust_free_quantity
                this.dataSend.products.push(_.clone(this.item))
              }
            } else {
              let checkExists = this.dataSend.products
                .filter(
                  p =>
                    p.product_id == el.product_id &&
                    p.uom_id == el.uom_id &&
                    p.promo_type_id == el.promotions.promo_type_id
                )
                .reduce((init, value) => (init = value), {})

              if (!_.isEmpty(checkExists)) {
                this.dataSend.products.splice(
                  this.dataSend.products.indexOf(checkExists),
                  1
                )
              }
            }
          })
        }
      }
    },
    addItem(saleCode, add_on_type = false) {
      if (!add_on_type) {
        this.item.product_id = saleCode.product_id
        this.item.uom_id = saleCode.uom_id
        this.item.quantity = this.quantity
        this.item.unit_price = this.defaultPrice(
          saleCode.product_id,
          this.dataSend.guest_level_id
        )
        this.item.discount_type = '%'
        this.item.discount_rate = this.discount_rate
        this.item.remarks = this.remarks
        this.item.discount_amount = 0
        this.item.total_after_discount = 0
        this.item.vat_rate = 0
        this.item.vat_amount = 0
        this.item.grand_total = 0
      } else {
        let checkExists = this.itemAddon
          .filter(
            i =>
              i.product_id == saleCode.product_id && i.uom_id == saleCode.uom_id
          )
          .reduce((init, value) => (init = value), {})
        if (!_.isEmpty(checkExists)) {
          this.itemAddon.splice(this.itemAddon.indexOf(checkExists), 1)
          return
        }
        this.itemAddon.push({
          product_id: saleCode.product_id,
          uom_id: saleCode.uom_id,
          quantity: 1,
          unit_price: saleCode.product_price
            ? saleCode.product_price.sale_price
            : 0,
          discount_type: '%',
          discount_rate: 0,
          remarks: null,
          discount_amount: 0,
          total_after_discount: 0,
          vat_rate: 0,
          vat_amount: 0,
          grand_total: 0
        })
      }
    },
    calculate() {
      this.dataSend.products.forEach(el => {
        var amount = _.ceil(el.quantity * el.unit_price, 2)
        el.discount_amount = _.ceil(
          el.discount_type == '%'
            ? amount * (el.discount_rate / 100)
            : el.discount_rate,
          2
        )
        el.vat_amount = _.ceil(amount * (el.vat_rate / 100), 2)
        el.total_after_discount = _.ceil(amount - el.discount_amount, 2)
        el.grand_total = _.ceil(el.total_after_discount + el.vat_amount, 2)
      })

      this.dataSend.fx_rate = _.ceil(this.exchangeRate, 2)
      this.dataSend.sub_total = _.ceil(
        _.sumBy(this.dataSend.products, function(o) {
          return o.grand_total
        }),
        2
      )
      this.dataSend.discount = 0
      this.dataSend.total_after_discount =
        this.dataSend.sub_total -
        _.round(this.dataSend.sub_total * (this.dataSend.discount / 100), 2)
      this.dataSend.vat_amount = _.round(
        this.dataSend.sub_total * (this.vatRate / 100),
        2
      )
      this.dataSend.grand_total = _.ceil(
        this.dataSend.sub_total + this.dataSend.vat_amount,
        2
      )
      this.removeFreeItemPerAmount()
    },
    setDataOnSelectedTable() {
      if (!_.isEmpty(this.tableSelected)) {
        this.dataSend.table_id = this.tableSelected.table_id
        this.dataSend.stock_out_id = this.tableSelected.stock_out_id
        this.dataSend.num_customer = this.tableSelected.num_customer
          ? this.tableSelected.num_customer
          : this.$store.state.restaurantSale.counterCheckout.num_customer
        this.dataSend.order_no = this.tableSelected.order_no
        this.dataSend.sub_total = this.tableSelected.sub_total
        this.dataSend.discount = this.tableSelected.discount
        this.dataSend.total_after_discount = this.tableSelected.total_after_discount
        this.dataSend.vat_amount = this.tableSelected.vat_amount
        this.dataSend.vat_rate = this.vatRate
        this.dataSend.grand_total = this.tableSelected.invoice_amount
        this.dataSend.fx_rate = this.exchangeRate
        this.dataSend.remark = this.tableSelected.remark
        this.dataSend.products = this.tableSelected.invoice_detail
        this.dataSend.guest_level_id = this.tableSelected.guest_level_id
        if (this.tableSelected.invoice_detail.length > 0) {
          this.showChooseFreeItems = false
        }
      }
    },
    async removeItem(row) {
      if (row.stock_out_id) {
        await this.$store
          .dispatch('restaurantSale/customerOrder/deleteItemOrdered', row)
          .then(() => {
            this.dataSend.products.splice(
              this.dataSend.products.indexOf(row),
              1
            )
          })
          .catch(error => {
            this.$toasted.error(error.messages)
          })
      } else {
        this.dataSend.products.splice(this.dataSend.products.indexOf(row), 1)
      }
      this.product_id_delete = null
      this.uom_id_delete = null
      this.quantity_delete = null
      this.unit_price_delete = null
      // remove promotion item
      var free_item = this.getPromotionItemFreeItem(
        row.product_id,
        row.uom_id,
        row.quantity
      )
      if (free_item) {
        free_item.map(el => {
          if (el.quantity > 0) {
            let checkExists = this.dataSend.products
              .filter(
                p =>
                  p.product_id == el.product_id &&
                  p.uom_id == el.uom_id &&
                  p.promo_type_id == el.promotions.promo_type_id
              )
              .reduce((init, value) => (init = value), {})

            if (!_.isEmpty(checkExists)) {
              this.dataSend.products.splice(
                this.dataSend.products.indexOf(checkExists),
                1
              )
            }
          }
        })
      }
    },
    close() {
      this.$bvModal.hide('modalPosItem')
    },
    updateCurrentTime() {
      this.currentDate = moment().format('dddd, MMM Do')
      this.currentTime = moment().format('LT')
    },
    checkBill() {
      this.$router.push({ name: 'counter-checkout-order' })
    },
    submitOrder() {
      this.promotion_free_item_per_amount = this.getPromotionFreeItemPerAmount(
        this.dataSend.sub_total
      )
      if (this.promotion_free_item_per_amount && this.showChooseFreeItems) {
        this.conditions = this.promotion_free_item_per_amount.conditions
        if (this.conditions.free_status == 'All') {
          this.selectAll(true)
        } else {
          this.selectAny()
        }
        this.visible = true
        return
      }

      this.waiting = true
      this.store(
        Object.assign({}, this.dataSend, {
          counter_id: parseInt(localStorage.getItem('counterId')),
          action_type: 'submit-order'
        })
      )
        .then(() => {
          this.$store
            .dispatch('restaurantSale/counterCheckout/fetchTables')
            .finally(() => {
              this.clearInput()
              this.waiting = false
              this.$router.push({ name: 'counter-checkout-order' })
            })
        })
        .catch(error => {
          this.waiting = false
          this.errors = new Errors(error.errors)
          if (this.errors.first('change_in_usd')) {
            this.$notification['error']({
              message: 'PAYMENT',
              description: this.errors.first('change_in_usd'),
              placement: 'bottomRight'
            })
          } else {
            this.$notification['error']({
              message: 'ORDER',
              description: error.message,
              placement: 'bottomRight'
            })
          }
        })
    },
    selectAll(e) {
      if (e) {
        this.selectedProductFree = []
        this.conditions.discount_items.map(el => {
          this.selectedProductFree.push({
            product_id: el.product_id,
            uom_id: el.uom_id,
            quantity: el.quantity
          })
          this.checked_all = true
        })
      } else {
        this.selectedProductFree = []
      }
    },
    selectAny() {
      this.selectedProductFree = []
      this.selectedProductFree.push({
        product_id: this.conditions.discount_items[0].product_id,
        uom_id: this.conditions.discount_items[0].uom_id,
        quantity: this.conditions.discount_items[0].quantity
      })
    },
    handleOk(e) {
      this.selectedProductFree.forEach(el => {
        let var_product = this.dataSend.products
          .filter(
            p =>
              p.product_id == el.product_id &&
              p.uom_id == el.uom_id &&
              p.unit_price == 0 &&
              p.promo_type_id == el.promo_type_id
          )
          .reduce((init, value) => (init = value), {})

        if (!_.isEmpty(var_product)) {
          var_product.quantity += el.quantity
          //move to index 0
          this.arraymove(
            this.dataSend.products,
            this.dataSend.products.indexOf(var_product),
            this.dataSend.products.length + 1
          )
        } else {
          this.item.product_id = el.product_id
          this.item.uom_id = el.uom_id
          this.item.quantity = el.quantity
          this.item.unit_price = 0
          this.item.discount_rate = 0
          this.item.promo_type_id = this.promotion_free_item_per_amount.promo_type_id
          this.item.remarks = this.promotion_free_item_per_amount.promotion_name
          this.item.promo_free_item_cond_id = this.conditions.promo_free_item_cond_id
          this.dataSend.products.push(_.clone(this.item))
        }
      })
      this.showChooseFreeItems = false
      this.visible = false
    },
    handleCancel(e) {
      this.visible = false
    },
    removeFreeItemPerAmount() {
      this.promotion_free_item_per_amount = this.getPromotionFreeItemPerAmount(
        this.dataSend.sub_total
      )
      if (this.promotion_free_item_per_amount) {
        let checkExists = this.dataSend.products
          .filter(
            p =>
              p.promo_free_item_cond_id !=
                this.promotion_free_item_per_amount.conditions
                  .promo_free_item_cond_id &&
              p.promo_free_item_cond_id != null &&
              p.promo_type_id ==
                this.promotion_free_item_per_amount.promo_type_id &&
              p.unit_price == 0
          )
          .reduce((init, value) => (init = value), {})

        if (!_.isEmpty(checkExists)) {
          this.dataSend.products.splice(
            this.dataSend.products.indexOf(checkExists),
            1
          )
          this.showChooseFreeItems = true
        }
      } else {
        let checkExists = this.dataSend.products
          .filter(p => p.promo_free_item_cond_id != null && p.unit_price == 0)
          .reduce((init, value) => (init = value), {})

        if (!_.isEmpty(checkExists)) {
          this.dataSend.products.splice(
            this.dataSend.products.indexOf(checkExists),
            1
          )
          this.showChooseFreeItems = true
        }
      }
    },
    clearInput() {
      this.dataSend.customer_id = null
      this.dataSend.table_id = null
      this.dataSend.num_customer = 0
      this.dataSend.order_no = null
      this.dataSend.sub_total = 0
      this.dataSend.discount = 0
      this.dataSend.total_after_discount = 0
      this.dataSend.vat_amount = 0
      this.dataSend.vat_rate = 0
      this.dataSend.grand_total = 0
      this.dataSend.fx_rate = 0
      this.dataSend.remark = null
      this.dataSend.products = []

      this.itemAddon = []
      this.selectedProductFree = []
    },
    backHome() {
      PageOptions.pageEmpty = false
      this.$router.push('/')
    },
    callback(val) {
      // console.log(val)
    },
    cookingStatus(cooking_status_id) {
      if (cooking_status_id == 1) {
        return 'text-info'
      }
      if (cooking_status_id == 2) {
        return 'text-primary'
      }
      if (cooking_status_id == 3) {
        return 'text-success'
      }
      return 'text-danger'
    },
    arraymove(arr, fromIndex, toIndex) {
      var element = arr[fromIndex]
      arr.splice(fromIndex, 1)
      arr.splice(toIndex, 0, element)
    },
    changeLanguage(language) {
      this.$root.$i18n.locale = language.code
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.add_to_card
        container.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest'
        })
      })
    },
    orderBy(items) {
      return orderBy(items, ['display_order'])
    },
    isAllowAdjustFreeQuantity(order) {
      if (
        (order.promo_type_id == 2 || order.promo_type_id == 4) &&
        !order.is_allow_adjust_free_quantity
      ) {
        return true
      }
      return false
    },
    openFullscreen() {
      if (!this.fullscreen) {
        this.fullscreen = !this.fullscreen
      }
      let elem = document.documentElement

      if (elem.requestFullscreen) {
        elem.requestFullscreen()
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen()
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari & Opera */
        elem.webkitRequestFullscreen()
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen()
      }
    },

    closeFullscreen() {
      if (this.fullscreen) {
        this.fullscreen = !this.fullscreen
      }
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      }
    }
  },
  watch: {
    dataSend: {
      handler() {
        this.calculate()
      },
      deep: true
    },
    activeKey: function(val) {
      this.onChangeSubCategory(val)
    },
    activeKeyCategory: function(val) {
      this.onChangeMainCategory(val)
    },
    'fetchOptions.search_value': debounce(function(search) {
      if (search) {
        this.category_id == null
        this.pro_group_id == null
        this.products = this.$store.state.restaurantSale.customerOrder.products
          .filter(p => _.includes([1, 2], p.product_type_id))
          .filter(
            p =>
              p.barcode
                .toLowerCase()
                .indexOf(this.fetchOptions.search_value.toLowerCase()) > -1 ||
              p.product_name_en
                .toLowerCase()
                .indexOf(this.fetchOptions.search_value.toLowerCase()) > -1 ||
              (p.product_name_kh
                ? p.product_name_kh
                    .toLowerCase()
                    .indexOf(this.fetchOptions.search_value.toLowerCase()) > -1
                : null)
          )
      } else {
        this.onChangeCategory(this.category_id)
        // if (this.category_id) {
        //   this.onChangeMainCategory(this.category_id)
        // }
        if (this.pro_group_id) {
          this.onChangeSubCategory(this.pro_group_id)
        }
      }
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    PageOptions.pageEmpty = false
    next()
  }
}
</script>
<style scoped>
.pos-product-img .img {
  object-fit: cover;
  width: 100%;
}
.pos-product-thumb .img {
  object-fit: cover;
  width: 100%;
}
.pos-customer .pos-sidebar .pos-sidebar-body .pos-table {
  padding: 0 10px;
}
.pos-customer .pos-sidebar .pos-sidebar-body .pos-table .pos-table-row {
  padding: 10px 0;
}
.form-group {
  margin-bottom: 0.3rem;
}
.border-bottom {
  border-bottom: 1px solid #74b1f1 !important;
}
.pos-customer .pos-menu .logo {
  padding: 12px;
}
.pos-customer .pos-menu .logo .logo-img {
  text-align: center;
  height: 105px;
}
.nav-container {
  top: 2;
  background: #f2f3f4;
  color: #5b6166;
}
.pos-sidebar-footer {
  background: #495057 !important;
  color: #f8f9fa;
  position: relative;
  padding: 10px 25px;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  -webkit-box-shadow: 0 -1px rgba(52, 58, 64, 0.1);
  box-shadow: 0 -1px rgba(52, 58, 64, 0.1);
}
.pos-customer .pos-sidebar .pos-sidebar-footer .btn-row {
  padding: 10px;
  margin: 0 -25px -10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.pos-customer .pos-sidebar .pos-sidebar-footer .btn-row .btn {
  border-radius: 10px !important;
}
.form-control-lg {
  background: #f2f3f4;
  color: #5b6166;
}
.pos-customer .pos-menu .nav.nav-tabs {
  margin-top: 8px;
}
.time {
  font-family: 'Times New Roman', serif;
  font-weight: bold;
  font-size: 28px;
  text-transform: uppercase;
  line-height: 1;
  text-align: center;
  background: linear-gradient(
    90deg,
    rgba(186, 148, 62, 1) 0%,
    rgba(236, 172, 32, 1) 20%,
    rgba(186, 148, 62, 1) 39%,
    rgb(250, 242, 125) 50%,
    rgba(186, 148, 62, 1) 60%,
    rgba(236, 172, 32, 1) 80%,
    rgba(186, 148, 62, 1) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: shine 3s infinite;
  background-size: 200%;
  background-position: left;
}
@keyframes shine {
  to {
    background-position: right;
  }
}
.vgt-global-search {
  padding: 2px;
}
.ant-modal-body {
  padding: 4px;
}
.tag-container {
  color: #fff;
  position: absolute;
  z-index: 3;
  top: 16px;
  left: 0;
  line-height: 24px;
  font-size: 0.7rem;
  font-weight: 600;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-flow: column nowrap;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  -webkit-box-align: start;
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: flex-start;
  text-transform: uppercase;
}
.tag-container .multi-tag {
  height: 24px;
  background-color: #d70f64;
  padding: 0 10px;
  margin-bottom: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-align-self: flex-start;
  -ms-flex-item-align: start;
  align-self: flex-start;
  max-width: 232px;
}
.ul-promotion {
  display: block;
  list-style-type: disc;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 20px;
  flex-wrap: wrap;
  display: flex;
}
.li-promotion-free-item {
  display: list-item;
  text-align: -webkit-match-parent;
  flex: 1 0 25%;
}
.search-box {
  padding: 12px 0 12px 12px;
  background: #6c757d;
  color: #ffffff;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  -webkit-box-align: center;
  align-items: center;
}
.pos-customer .pos-sidebar .pos-sidebar-header {
  padding: 16px 12px !important;
  background: #495057;
}
.pos-customer .pos-sidebar .pos-sidebar-header .order {
  background: #00acac;
  color: #ffffff;
  padding: 2px 6px;
}
hr {
  margin: 0.9375rem 0;
  color: #adb5bd;
  border: 0;
  opacity: 0.4;
}
.pos-customer .pos-content {
  overflow-y: auto;
  overflow-x: hidden;
}
@media (max-width: 991.98px) {
  .pos-customer .pos-menu .logo,
  .pos-sidebar-footer-left {
    display: none;
  }
  .pos-customer .pos-sidebar .pos-sidebar-header .back-btn {
    margin-left: 10px;
  }
  /* .pos-customer .pos-content .search-box {
    display: none;
  } */
  .pos-customer .pos-menu .nav-container {
    padding: 2px 0;
  }
  .pos-customer .pos-menu .nav.nav-tabs {
    margin-top: 2px;
  }
}
</style>
